// Webpack Imports
import JqueryService from './services/JqueryService';
// import BS
import 'bootstrap';
// import Fancybox
import { Fancybox } from '@fancyapps/ui';
import fbxLangBR from './fancybox-br';
// import Swiper
import SwiperService from './services/SwiperService';
import { SlidersProps } from './sliders/SlidersProps';
// import form
import '../../assets/js/jquery.flexdatalist.min';
import CustomMask from './Utils/CustomMask';
import ValidateService from './services/ValidateService';
import { FormLeadsOptions } from './FormsValidate/FormLeads';
import { FormNewsOptions } from './FormsValidate/FormNews';
import { FormCBDownloadOptions } from './FormsValidate/FormCBDownload';
import { FormCommentOptions } from './FormsValidate/FormComment';
// import CPT services
import { CustomPostTypeService } from './services/CustomPostTypeService';
// other imports
import 'jquery-match-height';
import EdifyHelpers from './helpers/EdifyHelpers';
import { removeNofflowLinksAttr } from './helpers/EdifyHelpers';

import { EscolasInepFlexDataList } from './flexdatalist/EscolasInepFlexDataList';
import { EscolasInepFlexDataListFree } from './flexdatalist/EscolasInepFlexDataListFree';

import ScriptsInstaller from './Utils/ScriptsInstaller';


(function ($) {

  ScriptsInstaller.installScripts();

  // Fancybox3 traducao
  Fancybox.defaults.l10n = fbxLangBR;

  EdifyHelpers.fancyboxModal(Fancybox);

  // jQuery Mask
  const masks = ['(00) 00000-0000', '(00) 0000-00009'];
  const elements = $('.mask-tel, input[type="tel"]');
  new CustomMask(masks, elements);

  /**
   * MAIN MENU
   */
  const mainNavbar = $('.main-navbar');
  EdifyHelpers.scrolledMenu(mainNavbar);
  EdifyHelpers.openSubmenuOnHover(mainNavbar);

  // Menu item Blog
  const blogMenuItem = $('.menu-item-blog')
  blogMenuItem.removeClass("active");

  // Botão de menu ativo
  EdifyHelpers.activeMobileMenu(mainNavbar);

  //Remove nofollow links attr 
  removeNofflowLinksAttr();

  // Icones do menu secundário
  const menuIconsList = [$('.i-menu-students'), $('.i-menu-schools')];
  EdifyHelpers.insertMenuIcons(mainNavbar.find('.main-menu:nth-child(2) .nav-link'), menuIconsList);
  EdifyHelpers.insertMenuIcons(mainNavbar.find('.secondary-menu .nav-link'), menuIconsList);

  /**
   * MENU DE REDES SOCIAIS DO FOOTER
   */
  // Lista de icones de redes sociais
  const socialIconsList = [$('.i-facebook'), $('.i-instagram'), $('.i-linkedin'), $('.i-youtube')];
  const socialItem = $('#menu-redes-sociais, #menu-redes-sociais-1').find('.nav-link');
  // Insere o texto do link numa tag para ser lido apenas para leitores de tela
  socialItem.each(function () {
    let content = $(this).html();
    $(this).empty().prepend(`<span class="sr-only">${content}</span>`)
  });
  EdifyHelpers.insertMenuIcons($('#menu-redes-sociais .nav-link'), socialIconsList);
  EdifyHelpers.insertMenuIcons($('#menu-redes-sociais-1 .nav-link'), socialIconsList);

  /**
   * CARROSSEIS / SLIDERS
   */

  // Padrao de cards com 5 colunas (desktop)
  // Usado na secao de diferenciais de Nossos Programas
  SwiperService.setConfig(SlidersProps.cards);
  // Webdoor
  SwiperService.setConfig(SlidersProps.webdoor);
  // Depoimentos
  SwiperService.setConfig(SlidersProps.testimonials);
  // Fotos (usado em materiais e galeria de fotos)
  SwiperService.setConfig(SlidersProps.pics);
  // Na midia
  SwiperService.setConfig(SlidersProps.press);
  // Cards de posts
  SwiperService.setConfig(SlidersProps.posts);

  /**
   * Custom NextSlider
   */
  EdifyHelpers.nextSlider(".implementation-cards-slider");

  /**
   * Seção de Stats
   * Contador de estatísticas que ativa só quando a seção aparece na tela
   * Instanciar serviço do jquery
   * chamar método dataCounter() para ativar o contador
   */
  const jqueryService = new JqueryService();
  var counterContainer = $('[data-stats-counter]');
  if (counterContainer.length) {
    jqueryService.dataCounter('scroll', counterContainer, { duration: 2000, easing: 'swing' });
  }

  /**
   * Form de leads
   */
  const validateFormLeads = new ValidateService(FormLeadsOptions);
  validateFormLeads.validate();

  /**
   * Form de news do rodape
   */
  const validateFormNews = new ValidateService(FormNewsOptions);
  validateFormNews.validate();

  /**
   * Pins do mapa do Brasil
   */

  const blockLocations = $('.block-school-locations');
  EdifyHelpers.insertMapPins(blockLocations);

  // Blog - Categorias
  // Botao de abrir as categorias no mobile
  const categoryToggle = $('.category-nav-toggle');
  EdifyHelpers.categoryIconsToggle(categoryToggle);

  /**
   * BTN SHARED
   */

  // Fixed search
  const fixSearchForm = $('#fixed-search-form');
  EdifyHelpers.fixedSearch(fixSearchForm);

  /**
   * Form de Comentarios
   */
  // Validacao do form
  const validateCommentForm = new ValidateService(FormCommentOptions);
  validateCommentForm.validate();

  $('#cancel-comment-reply-link').addClass('cancel-comment-reply-link ml-3');
  // Customização de colapse
  EdifyHelpers.replyFormShow();

  // Serviço para posts de Materiais Ricos
  CustomPostTypeService.init();

  // Aplica o flexdatalist com os parametros para localizacao
  EdifyHelpers.datalistLocation(EscolasInepFlexDataList);
  EdifyHelpers.datalistLocation(EscolasInepFlexDataListFree);

  // Aplica o match height absoluto nos card de key selling
  EdifyHelpers.absoluteMatchHeight($('.key-selling-card'));

  /**
   * Form de download conteudo cB
   */
  const validateFormCBDownloadOptions = new ValidateService(FormCBDownloadOptions);
  validateFormCBDownloadOptions.validate();

}(jQuery));